import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import PropTypes from "prop-types"
import Img from "gatsby-image"

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `useStaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `useStaticQuery`: https://www.gatsbyjs.org/docs/use-static-query/
 */

const Image = ({ source, styles, alt }) => {
  const data = useStaticQuery(graphql`
    query {
      phone: file(relativePath: { eq: "images/phone.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }

      steps: file(relativePath: { eq: "images/steps.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }

      info: file(relativePath: { eq: "images/info-image.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      woodCore: file(relativePath: { eq: "images/woodcore-image.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      founder: file(relativePath: { eq: "images/founder.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      toyin: file(relativePath: { eq: "images/tosin.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      cheche: file(relativePath: { eq: "images/cheche.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      digitalBank: file(relativePath: { eq: "images/digital-bank.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      neoBank: file(relativePath: { eq: "images/neo-bank.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      fintechs: file(relativePath: { eq: "images/fintechs.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      globalPayment: file(relativePath: { eq: "images/global-payment.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      cardSwitching: file(relativePath: { eq: "images/card-switching.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      heroImg: file(relativePath: { eq: "images/hero-background.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      kredi: file(relativePath: { eq: "images/kredi.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      lendsqr: file(relativePath: { eq: "images/lendsqr.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      onepipe: file(relativePath: { eq: "images/onepipe.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      openbanking: file(relativePath: { eq: "images/openbanking.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      woven: file(relativePath: { eq: "images/woven.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      smilingMan: file(relativePath: { eq: "images/smiling-man.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      smilingWoman: file(relativePath: { eq: "images/smiling-woman.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      externalIntegration: file(relativePath: { eq: "images/hand-and-phone.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Img
      fluid={data[source].childImageSharp.fluid}
      alt={alt}
      style={{ width: "100%", ...styles }}
    />
  )
}

Image.propTypes = {
  source: PropTypes.string,
  styles: PropTypes.object,
  alt: PropTypes.string,
}

Image.defaultProps = {
  source: "",
  styles: {},
  alt: "",
}

export default Image
